import {
  rlAxisData,
  rlAxisCData,
  rlAxisArcData,
} from "@/rlMxModules/rlDataClass/index";

import store from "@/store";
import {
  userSelect,
  getEntityById,
  saveDatabaseStore,
  getEntityData,
} from "@/rlMxModules/operate/operateApi";
import { Message } from "element-ui";
import { isPointsCoplanar } from "@/rlMxModules/operate/GraphicDataCal";
import { isMobileDevice } from "@/utils/matchMedia";
// 导出函数lineDraw，用于绘制直线
export const lineDraw = async (ptOrigin = null) => {
  if (store.state.inspectionStore.rightMenuActive.type == "DrawLine") {
    // 判断当前设备是移动端还是PC端，并根据设备类型选择绘制函数
    const drawFunction = "drawLineByPointsPreview"; // PC和移动端统一使用相同的函数
    // 创建一个新的rlAxisData对象
    const rlObject = new rlAxisData();
    try {
      // 调用绘制函数并等待结果返回
      const res = await rlObject[drawFunction](5, ptOrigin);
      // 如果res存在且有mcDbId，则保存到Vuex中
      if (res?.mcDbId) {
        store.commit("globalData/setCurrentMcDbId", res.mcDbId);
        return res;
      } else {
        // 如果在绘制过程中因为轴线长度小于5而没有创建对象，则继续绘制

        if (res && Object.keys(res).length === 0) {
          // 直接递归调用lineDraw函数，继续绘制
          return lineDraw();
        }
        //   res === undefined &&
        //   store.state.inspectionStore.endButtonShow &&
        //   store.state.inspectionStore.endButtonText === "结束绘制" &&
        //   isMobileDevice()
        // ) {
        //   return lineDraw();
        // }
      }
    } catch (error) {
      console.log("error", error);
    }
  }
  return false;
};

export const arcDraw = async (type) => {
  // 创建一个新的rlAxisData对象
  const rlObject = new rlAxisArcData();
  const drawFunction =
    type == 1
      ? "drawArcByPointsPreview" //三点确定圆弧
      : "drawArcByCenterRadiusPreview"; //圆心和半径确定圆弧

  // 调用绘制函数并等待结果返回
  const res = await rlObject[drawFunction](1);

  if (res?.mcDbId) {
    store.commit("globalData/setCurrentArcMcDbId", res.mcDbId);
  }
  return false;
};

// 绘制轴线草图
export const drawAxisSketch = async (ptOrigin = null) => {
  if (store.state.inspectionStore.rightMenuActive.type == "DrawSketchLine") {
    // 判断当前设备是移动端还是PC端，并根据设备类型选择绘制函数
    const drawFunction = store.state.app.isPcMode
      ? "drawLineByPointsPreview" // 如果是PC端，使用drawLineByPoints函数
      : "drawLineByPointsPreview"; // 如果是移动端，使用drawLineByPoints函数（这里PC和移动端使用相同的函数）

    // 创建一个新的rlAxisData对象
    const rlObject = new rlAxisCData();
    // 调用绘制函数并等待结果返回
    const res = await rlObject[drawFunction](5, ptOrigin);
    if (res?.mcDbId) {
      store.commit("globalData/setCurrentMcDbId", res.mcDbId);
      return res;
    } else {
      if (res && Object.keys(res).length === 0) {
        // 如果res为空，则继续绘制
        return drawAxisSketch();
      }
    }
  }
  return false;
};

// 绘制上节点高
export const drawUpperNodeHeight = async (newHDiff) => {
  try {
    // Message({
    //   type: "info",
    //   message: "请选择设置上节点高的节点",
    //   showClose: true,
    // });

    const setUpperNodeHeight = async (ids) => {
      if (ids.length === 0) {
        Message.info({
          type: "info",
          message: "请选择设置上节点高的节点",
          showClose: true,
        });
        return;
      }
      // 绘制步数
      store.commit("globalData/setCanAddRawStep", true);
      let updateSlabArray = [];
      for (let i = 0; i < ids.length; i++) {
        let modelObj = getEntityById(ids[i]);
        if (modelObj && modelObj.classTypeName == "rlJoint") {
          modelObj.drawHDiff(newHDiff);

          let gridIds = modelObj.m_gridIds;
          for (let j = 0; j < gridIds.length; j++) {
            let gridObj = getEntityData({
              Guid: gridIds[j],
              classTypeName: "rlGrid",
            });
            if (gridObj) {
              updateSlabArray.push(...gridObj.m_slabIds);
            }
          }
        }
      }
      //去除重复的slabIds
      updateSlabArray = [...new Set(updateSlabArray)];

      //更新slab
      for (let i = 0; i < updateSlabArray.length; i++) {
        let slabObj = getEntityData({
          Guid: updateSlabArray[i],
          classTypeName: "rlSlab",
        });
        if (slabObj) {
          slabObj.saveEditRevokeData();
          slabObj.updateThisObj(slabObj);
        }
      }

      await saveDatabaseStore();
      rlAppObj.rlMxDrawObject.updateDisplay();
    };

    userSelect(setUpperNodeHeight);
  } catch (error) {
    console.log("上节点设置报错", error);
  }
};

//显示所有节点的HDiff
export const showAllJointsHDiff = (erase = false) => {
  const allJoints = store.state.rlEntData.totalEntityData["rlJoint"];
  allJoints.forEach((item) => {
    item.drawHDiff(null, erase);
  });
  rlAppObj.rlMxDrawObject.updateDisplay();
};
